import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, allowedRoles = [], allowTeamMembers = false }) {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  // Check if user passed from AuthCallback (avoid double redirect)
  if (location.state?.user) {
    return children;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If role allowed OR team-member fallback enabled for any authed user
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    if (allowTeamMembers) {
      // Allow through; the page/API will gate by team_permissions
      return children;
    }
    // Redirect to appropriate dashboard based on role
    switch (user?.role) {
      case 'admin':
        return <Navigate to="/admin" replace />;
      case 'vendor':
        return <Navigate to="/vendor" replace />;
      case 'b2b':
        return <Navigate to="/b2b" replace />;
      case 'organization':
        return <Navigate to="/organization/dashboard" replace />;
      case 'sales_agent':
        return <Navigate to="/sales" replace />;
      case 'venue_owner':
        return <Navigate to="/venue-dashboard" replace />;
      case 'client':
        return <Navigate to="/dashboard" replace />;
      default:
        return <Navigate to="/team" replace />;
    }
  }

  return children;
}
